/*  Shared  */
import { Usage } from 'application/Shared/Components/Usage';

/*  React  */
import React from 'react';

export const UsageChartCell = (props) => {
    const { row, ...rest } = props;
    return (
        <Usage
            sx={{ maxHeight: '32px' }}
            usageChart={row.original.usageChart}
            usage={row.original.usage}
            {...rest}
        />
    );
};
